var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewfinderWelcomeAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "170px",
    height: "182px",
    viewBox: "0 0 170 182",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "illustration") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 80,
    cy: 80,
    r: 80
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-23.3%",
    y: "-58.3%",
    width: "146.7%",
    height: "216.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 8,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.0911175272 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "investment-viewfinder",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "welcome",
    transform: "translate(-635.000000, -127.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "box",
    transform: "translate(135.000000, 89.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "illustration",
    transform: "translate(505.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user",
    transform: "translate(0.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "base",
    fill: "#F4F4F4",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)",
    fill: "#707487",
    fillRule: "nonzero",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.000000, 49.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.8289963,58.6878857 C59.1378736,58.6878857 69.9278662,45.5502857 69.9278662,29.3441143 C69.9278662,13.1376 63.2587891,0 45.8289963,0 C28.3992035,2.59907435e-15 21.7294424,13.1376 21.7294424,29.3441143 C21.7294424,45.5502857 32.5194349,58.6878857 45.8289963,58.6878857 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2937546,99.3075429 C90.8474349,71.076 87.169487,63.0315429 59.0246691,57.9394286 C59.0246691,57.9394286 55.062855,63.0003429 45.8286543,63.0003429 C36.5944535,63.0003429 32.6319554,57.9394286 32.6319554,57.9394286 C4.79426022,62.976 0.892639405,70.9011429 0.379628253,98.3904 C0.337561338,100.635086 0.318066914,100.753029 0.310542751,100.492457 C0.312252788,100.980686 0.314304833,101.883771 0.314304833,103.458514 C0.314304833,103.458514 7.0149145,117 45.8286543,117 C84.64171,117 91.3430037,103.458514 91.3430037,103.458514 C91.3430037,102.446743 91.3436877,101.7432 91.3447138,101.264571 C91.3371896,101.425714 91.3221413,101.113371 91.2937546,99.3075429 Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "bubbles",
    filter: "url(#filter-3)",
    transform: "translate(5.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 1,
    transform: "translate(0.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "base",
    stroke: "#8CCC33",
    fill: "#FFFFFF",
    cx: 20,
    cy: 20,
    r: 19.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "ic_chart",
    transform: "translate(8.000000, 8.000000)",
    fill: "#0068AE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,9 L14,9 L14,20 L10,20 L10,9 Z M15,4 L19,4 L19,20 L15,20 L15,4 Z M5,11 L9,11 L9,20 L5,20 L5,11 Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: 2,
    transform: "translate(55.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "base",
    stroke: "#8CCC33",
    fill: "#FFFFFF",
    cx: 20,
    cy: 20,
    r: 19.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "ic_toggle",
    transform: "translate(8.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(0.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    fill: "#0068AE",
    x: 0,
    y: 3,
    width: 24,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#0068AE",
    fill: "#FFFFFF",
    cx: 16,
    cy: 5,
    r: 4.5
  })))), /*#__PURE__*/React.createElement("g", {
    id: 3,
    transform: "translate(110.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "base",
    stroke: "#8CCC33",
    fill: "#FFFFFF",
    cx: 20,
    cy: 20,
    r: 19.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "ic_pie_chart",
    transform: "translate(8.000000, 8.000000)",
    fill: "#0068AE",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0028052,4 C7.58722726,4 4,7.58704627 4,12.0028052 C4,16.4113249 7.58704627,20 12.0028052,20 C16.4113249,20 20,16.4115059 20,12.0028052 C20,7.58722726 16.4115059,4 12.0028052,4 Z M12,5 C15.8974023,5.18636925 19,8.3280224 19,12.1810236 C19,14.0348884 18.2760972,15.7261492 17.0925422,17 L12.0001833,12.0303915 L12,5 Z"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewfinderWelcomeAvatar);
export default __webpack_public_path__ + "static/media/viewfinder_welcome_avatar.1b83461ee22fda4053fc81bb40bbde7c.svg";
export { ForwardRef as ReactComponent };